// removed by extract-text-webpack-plugin
module.exports = {"resendText":"resendText__uC4oU","resendOtpText":"resendOtpText__1QDw2"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/common/resendOtp/style.css
// module id = sNPd
// module chunks = 1 3 323 354 360